import {combineReducers} from "redux";
import contactReducer from "./contactReducer";
import footerReducer from "./footerReducer";
import clientReducer from "./clientReducer";
import formDataReducer from "./formDataReducer";

const appReducer = combineReducers({
    client: clientReducer,
    contact : contactReducer,
    footer :  footerReducer,
    formData: formDataReducer
});

const rootReducer = (state, action) => {
    if (action.type === 'reset') {
      state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;